import { FormikErrors } from "formik";
import { useScrollToError } from "@me-team/host/src/utils/useScrollToError";
import React from "react";

interface ScrollToErrorHelperProps {
    errors: FormikErrors<any>;
    submitClickedCount: number;
    refs?: Record<string, React.RefObject<HTMLElement>>;
}

const ScrollToErrorHelper: React.FC<ScrollToErrorHelperProps> = ({ errors, submitClickedCount, refs }) => {
    useScrollToError({ errors, submitClickedCount, refs });
    return null;
};

export default ScrollToErrorHelper;
